<ng-container *ngIf="applicationPermissionItems.length > 0">

  <mat-tab-group>

    <mat-tab *ngFor="let item of applicationPermissionItems" [label]="getApplicationName(item)">

      <div class="applications-form">

        <p *ngIf="item.config.application?.description" class="application-description">
          {{ item.config.application.description }}
        </p>

        <div
          fxLayout="row wrap"
          fxLayoutGap="15px"
          [formGroup]="getApplicationGroup(item.key)">

          <ng-container *ngIf="!disabled">
            <ng-container *ngFor="let permission of item.config.permissions">

              <mat-form-field class="applications-form-field" fxFlex="50" fxFlex.lt-md="100">
                <mat-label>{{ permission.displayName }}</mat-label>

                <mat-select [required]="false" [formControlName]="permission.module">
                  <mat-option *ngFor="let role of permission.roles" [value]="role">
                    {{ getRoleLabel(item.config, role) }}
                  </mat-option>
                </mat-select>

                <button
                  *ngIf="getApplicationGroup(item.key).get(permission.module)?.value"
                  matSuffix
                  mat-icon-button
                  type="button"
                  aria-label="Clear"
                  (click)="getApplicationGroup(item.key).get(permission.module)?.setValue('none'); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-hint>
                  {{ permission.description }}
                  <ng-container *ngIf="isIndividualPermission(permission)">
                    · Nie dziedziczy z działu
                  </ng-container>
                </mat-hint>
              </mat-form-field>

            </ng-container>
          </ng-container>

          <ng-container *ngIf="disabled">
            <ng-container *ngFor="let permission of item.config.permissions">
              <div class="applications-form-field" fxFlex="50" fxFlex.lt-md="100">
                <app-detail
                  [header]="permission.displayName"
                  [value]="getRoleLabel(
                    item.config,
                    getPermissionValue(item.key, permission.module)
                  )">
                </app-detail>

                <small class="application-permission-info">
                  {{ getAssignmentModeLabel(permission) }}
                </small>
              </div>
            </ng-container>
          </ng-container>

        </div>

      </div>

    </mat-tab>

  </mat-tab-group>

</ng-container>
